import * as React from 'react';
import type { SVGProps } from 'react';
const SvgSuccessFull = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    aria-label="Success_full"
    viewBox="0 0 20 20"
    {...props}
  >
    <circle cx={10} cy={10} r={8} fill="url(#Success_full_svg__a)" />
    <path
      fill="#fff"
      fillRule="evenodd"
      d="M14.33 6.727a.777.777 0 0 1 0 1.099l-5.29 5.291c-.42.42-1.101.423-1.525.007l-2.083-2.046A.777.777 0 0 1 6.521 9.97l1.75 1.72 4.962-4.963a.776.776 0 0 1 1.098 0Z"
      clipRule="evenodd"
    />
    <defs>
      <linearGradient
        id="Success_full_svg__a"
        x1={15}
        x2={-5}
        y1={13.75}
        y2={13.333}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#62AB57" />
        <stop offset={1} stopColor="#C2E5BD" />
      </linearGradient>
    </defs>
  </svg>
);
export default SvgSuccessFull;
